import Vue from 'vue';

const that = Vue.prototype;

// 动画定时器存储对象
Vue.prototype.AnimateTimeObj = {};

// 全局动画dom滚动加载效果函数
Vue.prototype.setDomAnimate = (callback = (num)=>{}) => {
	// console.log(that)
	$('#app').scrollTop(0);
	let offsetTop = [];
	$('.animateDom').each((index, el) => {
		let centerHeight = $(el).outerHeight(true) / 2.4;
		let numPx = $(el).offset().top - $(window).height();
		offsetTop.push(numPx);
	});
	let len = offsetTop.length;
	let tagIndex = 0;
	$('#app').scroll(() => {
		let difference = $('#app').height() - offsetTop[0] <= 0 ? 0 : $('#app').height() - offsetTop[0];
		
		let y = $('#app').scrollTop() + $('#app').height() - difference;
		// let y = $('#app').scrollTop() + $('#app').height();
		let goConditions = true;
		let status = false;
		try {
			offsetTop.forEach((i, index) => {
				if (tagIndex < len - 1) {
					if (i > y) {
						if (index != 0) {
							tagIndex = index - 1;
						}
						let className = $('.animateDom')
							.eq(tagIndex)
							.attr('class');
						if (className.indexOf('animate-fadeInUp') == -1) {
							$('.animateDom')
								.eq(tagIndex)
								.addClass('animate-fadeInUp');
							status = true;
						}
						throw '完成';
					}
				}
			});
		} catch (e) {
			//TODO handle the exception
			// console.log(e)
			if (e == '完成') {
				goConditions = false;
			}
		}
		if (goConditions && y > offsetTop[tagIndex + 1]) {
			tagIndex += 1;
			let className = $('.animateDom')
				.eq(tagIndex)
				.attr('class');
			if (className.indexOf('animate-fadeInUp') == -1) {
				$('.animateDom')
					.eq(tagIndex)
					.addClass('animate-fadeInUp');
					status = true;
			}
		}
		if(status){
			callback(tagIndex)
		}
		// console.log(tagIndex);
	});
};
// 全局部分模块顺序加载动画设置函数
Vue.prototype.setModuleAnimate = (targetClassName, className) => {
	let dom = $('.' + targetClassName);
	let len = dom.length;
	let index = 0;
	that.AnimateTimeObj[targetClassName] = setInterval(() => {
		if (index < len) {
			let classText = dom.eq(index).attr('class') || '';
			if (classText.indexOf(className) == -1) {
				dom.eq(index).addClass(className);
			}
			index += 1;
		} else {
			if (that.AnimateTimeObj[targetClassName]) {
				clearInterval(that.AnimateTimeObj[targetClassName]);
				that.AnimateTimeObj[targetClassName] = null;
			}
		}
	}, 380)
};
// 全局部分模块顺序加载动画点击设置函数
Vue.prototype.setModuleClick = (targetClassName, className) => {
	let dom = $('.' + targetClassName);
	let classText = dom.attr('class') || '';
	if (classText.indexOf(className) == -1) {
		setTimeout(()=>{
			dom.addClass(className);
		}, 300)
		
	}
};
Vue.prototype.setClickAnimate = (e, targetClassName, className) => {
	// console.log(e)
	$('.' + targetClassName).removeClass(className);
	let classText = $(e.currentTarget).attr('class');
	if (classText.indexOf(className) == -1) {
		$(e.currentTarget).addClass(className);
	}
}
